import { extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Button } from '@tesla/design-system-react';
import { Checkbox } from './Checkbox.js';
import { CheckboxGroup } from './CheckboxGroup.js';
import { RadioGroup } from './RadioGroup.js';
import { Select } from './Select.js';
import { Input } from './Input.js';
import { TextArea } from './TextArea.js';
import { OptionGroup } from './OptionGroup.js';
import { SwitchToggle } from './SwitchToggle.js';
import { FormGroup } from './FormGroup.js';
import { ArrayField } from './ArrayField.js';
import { DateInput } from './DateInput.js';
import { DateRangeInput } from './DateRangeInput.js';
import { PhoneInput } from './PhoneInput.js';
import { Password } from './Password.js';
import { Search } from './Search.js';
import { SelectSearch } from './SelectSearch.js';
import { AddButton } from './AddButton.js';
import { RemoveButton } from './RemoveButton.js';
import { Hidden } from './Hidden.js';
import { RangeSlider } from './RangeSlider.js';
import { Dropdown } from './Dropdown.js';
import { InlineDropdown } from './InlineDropdown.js';
import { FileUpload } from './FileUpload.js';

var adapter = {
  button: Button,
  object: FormGroup,
  array: ArrayField,
  checkbox: Checkbox,
  "boolean": Checkbox,
  radio: RadioGroup,
  select: Select,
  input: Input,
  string: Input,
  textarea: TextArea,
  number: function number(props) {
    return /*#__PURE__*/React.createElement(Input, _extends({}, props, {
      type: "number"
    }));
  },
  option_group: OptionGroup,
  checkbox_group: CheckboxGroup,
  switch_toggle: SwitchToggle,
  date: DateInput,
  date_range: DateRangeInput,
  phone: PhoneInput,
  password: Password,
  search: Search,
  range: RangeSlider,
  select_search: SelectSearch,
  add: AddButton,
  remove: RemoveButton,
  hidden: Hidden,
  dropdown: Dropdown,
  inline_dropdown: InlineDropdown,
  file: FileUpload,
  withOptions: {
    string: Select,
    // number: Select,
    array: CheckboxGroup
  }
};

export { adapter };
